export class PlotLibreError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.name = "PlotLibreError";
        this.code = code;
    }
}
export class PlotDefinitionNotFoundError extends PlotLibreError {
    constructor(type) {
        super("PLOT_DEFINITION_NOT_FOUND", `No plot definition is registered for "${type}".`);
        this.name = "PlotDefinitionNotFoundError";
    }
}
export class DuplicatePlotDefinitionError extends PlotLibreError {
    constructor(type) {
        super("DUPLICATE_PLOT_DEFINITION", `A plot definition is already registered for "${type}".`);
        this.name = "DuplicatePlotDefinitionError";
    }
}
export class PlotFeatureNotFoundError extends PlotLibreError {
    constructor(id) {
        super("PLOT_FEATURE_NOT_FOUND", `No plot feature exists with id "${id}".`);
        this.name = "PlotFeatureNotFoundError";
    }
}
export class DuplicatePlotFeatureError extends PlotLibreError {
    constructor(id) {
        super("DUPLICATE_PLOT_FEATURE", `A plot feature already exists with id "${id}".`);
        this.name = "DuplicatePlotFeatureError";
    }
}
export class InvalidPlotFeatureError extends PlotLibreError {
    constructor(message) {
        super("INVALID_PLOT_FEATURE", message);
        this.name = "InvalidPlotFeatureError";
    }
}
//# sourceMappingURL=errors.js.map